export const FORTY_N_DEBUG = '40n_debug';
